import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../createApiConfig'

export const reportsApiSlice = createApi({
  reducerPath: 'reportsApiSlice',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['ReportRequests'],
  endpoints: builder => ({
    getReports: builder.query({
      query: params => ({
        url: '/reports/',
        params
      })
    }),

    getReportRequests: builder.query({
      query: params => ({
        url: '/reports/requests',
        params
      }),
      providesTags: ['ReportRequests']
    }),

    createReportRequest: builder.mutation({
      query: body => ({
        url: '/reports/requests/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['ReportRequests']
    })
  })
})

export const {
  useLazyGetReportsQuery,
  useGetReportRequestsQuery,
  useLazyGetReportRequestsQuery,
  useCreateReportRequestMutation
} = reportsApiSlice
